import { useCallback } from "react"
import { Platform } from "react-native"
import { useDispatch, useSelector } from "react-redux"

import { setIsLiveModeEnabled } from "../../../data/redux/actions/liveMode"
import LiveEventBuffer from "../../../data/services/LiveEventBuffer"
import { stopCallService } from "./callKeep/CallKeepSetup"

const IS_CALLKEEP_COMPATIBLE = Platform.OS !== "web"

/**
 * Hook that provides a callback to disable live mode and stop call service.
 *
 * @returns {{ disconnectFromLive: Function }}
 */
export function useDisconnectFromLive() {
    const dispatch = useDispatch()
    const hasPhonePermission = useSelector(
        (state) => state.liveMode?.hasPhonePermission
    )

    const disconnectFromLive = useCallback(async () => {
        // Flush remaining events and cleanup listeners before disconnecting
        await LiveEventBuffer.getInstance().destroy()
        dispatch(setIsLiveModeEnabled(false))
        if (IS_CALLKEEP_COMPATIBLE && hasPhonePermission) {
            stopCallService().then()
        }
    }, [dispatch, hasPhonePermission])

    return {
        disconnectFromLive,
    }
}
